import React, { Component } from "react";
import { Tooltip } from "@cloud/atom-ui";
import Avatar from "./avatar.js";
import Input from "./input.js";
import TextArea from "./textarea.js";
import MultiPic from "./file";
import Selectd from "./select";
import Radioed from "./radio";
import banner from "@src/assets/banner.png";
import "./index.less";
import constant from "@src/utils/constant";
import DOMPurify from "dompurify";
import QuestionCircleOutlined from "@cloud/atom-ui-icons/QuestionCircleOutlined";
import { replaceHtmlDomain } from "@src/utils/common";

export default class Assembly extends Component {
  components = {
    0: Avatar,
    1: Input,
    2: TextArea,
    3: MultiPic,
    4: Selectd,
    5: Radioed,
  };
  state = {
    isShow: false,
    tigs1: "应用的唯一标识，用于接口鉴权获取access_token", //client_id的提示语
    tigs2: "应用密钥，用于接口鉴权获取access_token", //client_secret的提示语
  };

  displaySecret = (bool) => {
    this.setState({
      isShow: bool,
    });
  };

  resetSecret = () => {
    this.props.resetSecret();
  };

  render() {
    let { item, change } = this.props;
    let {
      type,
      isEdit,
      imgType,
      readyType,
      tigType,
      appType = "",
      isGray,
      siteType,
    } = item;
    const Type = this.components[type];
    // 两个跳转地址
    const openAddress = /localhost/.test(window.location.hostname)
      ? constant.GAMMA_ENVIRONMENT
      : "";
    // 两个跳转地址
    const appCubeUrl = window?.location?.hostname.includes('uat')
      ? constant.CLOUDUAT_URL
      : constant.OPEN_URL;
    return (
      <>
        <div
          className="item-list"
          style={{ display: item.isShow && item.isEdit ? "none" : "" }}
        >
          <div className="item-left">
            {item.title}
            {item.isEdit && item.require && (
              <span style={{ color: "red" }}>*</span>
            )}
            {isEdit ? <div style={{ height: "25px" }}></div> : null}
            {
              tigType === 'client_id'
                ?
                <Tooltip placement="top" title={this.state.tigs1} overlayStyle={{ maxWidth: "285px", width: "285px" }}>
                  <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
                </Tooltip> : tigType === 'client_secret'
                  ? <Tooltip placement="top" title={this.state.tigs2}>
                    <QuestionCircleOutlined style={{ marginLeft: '5px' }} />
                  </Tooltip>
                  : null
            }
          </div>
          <div className="item-right">
            <Type {...this.props}></Type>
            {item.isEdit && (
              <>
                {imgType === "default" ? (
                  <p
                    className="uploadLink"
                    onClick={() =>
                      window.open(`${openAddress}/docs/#/990hh0/g2r4j4/fh5os9`)
                    }
                  >
                    查看图标制作规范
                  </p>
                ) : null}
                {appType == 2 && isGray && siteType && siteType != 2 ? (
                  <div className="tip">
                    <p>
                      <span>
                        输入移动端H5地址，发布上线即可访问轻应用。如想低代码开发，试试
                        {isGray}
                      </span>
                      <a
                        href={`https://${location.hostname}/docs/#/docInfo?docId=165896421944356864`}
                        target="_blank"
                      >
                        三步上手应用开发神器Astro Zero
                      </a>
                    </p>
                    <div>
                      <a
                        href={appCubeUrl}
                        style={{ display: "block", width: "194px" }}
                        target="_blank"
                      >
                        <img
                          src={banner}
                          style={{
                            display: "block",
                            width: "600px",
                            height: "132px",
                          }}
                        />
                      </a>
                    </div>
                  </div>
                ) : (
                  <div
                    className={imgType === "default" ? "tip imgTip" : "tip"}
                    style={{
                      display:
                        readyType === "readyType" ? "inherit" : "inline-block",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(replaceHtmlDomain(item.tip)),
                    }}
                  ></div>
                )}
              </>
            )}
            {isEdit ? (
              <div className="tip error">
                {item.isEdit && item.isShowError && item.errorTip}
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}
